import React from 'react';
import { getEntityId } from 'helpers/entityId';
import Button from 'components/base/Button';
import { useMutation, useQueryClient } from 'react-query';
import { UNASSIGN_JOB } from 'services/api/job';
import { getItemFromStore } from 'helpers/utils';
import { Employee } from 'data/users';

interface UnassignButtonProps {
  userId: string;
  jobId?: string;
  supervisorId?: string;
  onUnassignSuccess?: () => void;
  onUnassignError?: (error: unknown) => void;
}

const UnassignButton: React.FC<UnassignButtonProps> = ({
  userId,
  jobId,
  supervisorId,
  onUnassignSuccess,
  onUnassignError
}) => {
  const queryClient = useQueryClient();
  const authUser: Employee = getItemFromStore('authUser');
  const { mutate, isLoading } = useMutation(
    () => UNASSIGN_JOB({ userIds: userId, id: String(jobId) }),
    {
      onSuccess: () => {
        // Invalidate and refetch relevant queries
        queryClient.invalidateQueries(['job', jobId]);
        queryClient.invalidateQueries('getJobs');
        if (onUnassignSuccess) {
          onUnassignSuccess();
        }
      },
      onError: error => {
        if (onUnassignError) {
          onUnassignError(error);
        }
      }
    }
  );

  const handleUnassign = () => {
    mutate();
  };

  return (
    <>
      {supervisorId !== undefined && supervisorId == getEntityId(authUser) ? (
        <Button
          onClick={handleUnassign}
          variant="link"
          className="p-0 text-decoration-none text-danger"
          disabled={isLoading}
        >
          {isLoading ? 'Loading...' : 'Unassign'}
        </Button>
      ) : (
        <></>
      )}
    </>
  );
};

export default UnassignButton;
